import React from 'react';
import { Navigate } from 'react-router-dom';
import { AccountingExportsRoutes } from '../../../Router/path';

const AccountingExportPage = () => <Navigate to={AccountingExportsRoutes.root} replace />;

export default AccountingExportPage;
